import React, { useState } from 'react';
import '../css/Dashboard.css';

const Sidebar = () => {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  return (
    <div className="sidebar">
      {/* Search Bar with SVG Icon */}
      <div className="search-bar">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#808080" /* Icon color */
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="search-icon"
        >
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="16" y1="16" x2="22" y2="22"></line>
        </svg>
        <input
          type="text"
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="Search..."
          className="search-input"
        />
      </div>

      <div className="title">All Projects</div>
      <ul>
        <li className="current">NEOM Green Hydrogen</li>
        <li>NEOM Training</li>
        {/* Add more projects as needed */}
      </ul>
    </div>
  );
};

export default Sidebar;
